import {
  ADD_SPEAKER_LABEL,
  GET_SLATE_DATA_FAILED,
  GET_SLATE_DATA_REQUEST,
  GET_SLATE_DATA_SUCCESS,
  RESET_EDITOR_STATE,
  UPDATE_COMPLETED_BY_INDEX,
  UPDATE_COMPLETED_PERCENTAGE,
  UPDATE_FLAG_SLATE_DATA,
  UPDATE_SCROLL_TO_INDEX_VALUE,
  UPDATE_SLATE_DATA,
  UPDATE_SLATE_DATA_LOADING_STATE,
  UPDATE_SLATE_IS_CLAIM,
  UPDATE_SLATE_IS_DIRTY,
  UPDATE_SLATE_NOT_COMPLETED_NODES,
  UPDATE_SLATE_SELECTED_NODE,
  UPDATE_SLATE_VENDOR_NOTES,
} from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  data: null,
  isUpdated: true,
  completedPercentage: 0,
  speakerLabels: [],
  error: null,
  isDirty: false,
  notCompletedNodes: [],
  selectedNode: null,
  vendorNotes: null,
  isClaim: false,
  scrollToIndexValue: null,
};

const getNotCompletedNodes = (data = []) => {
  const dataWithIndex = data?.map((i, index) => ({ ...i, index })) ?? [];
  const filterData = dataWithIndex?.filter((i) => !i.completed);
  return (filterData ?? [])?.map((i) => i?.index);
};

const getSlateDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SLATE_DATA_REQUEST:
      return { ...state, loading: true };
    case GET_SLATE_DATA_SUCCESS:
      const parsedData = JSON.parse(action.payload)?.data || [];
      const completedData = parsedData.filter((i) => i.completed);

      const completedPercentage =
        parsedData.length > 0 ? ((completedData.length / parsedData.length) * 100).toFixed(2) : '0.00';
      return {
        ...state,
        loading: false,
        data: JSON.parse(action.payload)?.data,
        // speakerLabels: action.payload.speakerLabels,
        isUpdated: true,
        notCompletedNodes: getNotCompletedNodes(JSON.parse(action.payload)?.data),
        completedPercentage: completedPercentage || 0,
      };
    case GET_SLATE_DATA_FAILED:
      return { ...state, loading: false, error: action.payload };
    case ADD_SPEAKER_LABEL:
      if (state.speakerLabels.some((label) => label === action.payload)) {
        return state;
      }
      return {
        ...state,
        speakerLabels: [...state.speakerLabels, action.payload],
      };
    case UPDATE_SLATE_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case UPDATE_FLAG_SLATE_DATA:
      return {
        ...state,
        isUpdated: action.payload,
      };
    case UPDATE_COMPLETED_PERCENTAGE: {
      const { id, completed } = action.payload;
      const updatedData = state.data.map((node) => (node.id === id ? { ...node, completed } : node));

      const completedNodes = updatedData.filter((node) => node.completed);
      const completedPercentage = ((completedNodes.length / updatedData.length) * 100).toFixed(2);
      return {
        ...state,
        data: updatedData,
        completedPercentage,
        notCompletedNodes: getNotCompletedNodes(updatedData),
      };
    }
    case UPDATE_COMPLETED_BY_INDEX: {
      const { id, completed } = action.payload;
      const index = id;
      if (index < 0 || index >= state.data.length) {
        return state; // Out-of-bounds index, return current state
      }

      const updatedData = state.data.map((node, i) => (i === index ? { ...node, completed } : node));

      const completedNodes = updatedData.filter((node) => node.completed);
      const completedPercentage = ((completedNodes.length / updatedData.length) * 100).toFixed(2);

      return {
        ...state,
        data: updatedData,
        completedPercentage,
        notCompletedNodes: getNotCompletedNodes(updatedData),
      };
    }
    case UPDATE_SLATE_DATA_LOADING_STATE:
      return {
        ...state,
        loading: action.payload,
      };
    case UPDATE_SLATE_IS_DIRTY:
      return {
        ...state,
        isDirty: action.payload,
      };
    case UPDATE_SLATE_SELECTED_NODE:
      return {
        ...state,
        selectedNode: action.payload,
      };
    case UPDATE_SLATE_NOT_COMPLETED_NODES:
      return {
        ...state,
        notCompletedNodes: action.payload,
      };
    case UPDATE_SLATE_VENDOR_NOTES:
      return {
        ...state,
        vendorNotes: action.payload,
      };
    case UPDATE_SLATE_IS_CLAIM:
      return {
        ...state,
        isClaim: action.payload,
      };
    case RESET_EDITOR_STATE:
      return initialState;
    case UPDATE_SCROLL_TO_INDEX_VALUE:
      return { ...state, scrollToIndexValue: action.payload };
    default:
      return state;
  }
};

export default getSlateDataReducer;
